import has from "lodash/has";
import { GroupOption, Option, OptionOriginal, SelectOptions } from "PFTypes/options";

export const areOptionsGrouped = <T extends OptionOriginal>(
  options?: SelectOptions<T>
): options is GroupOption<T>[] => {
  if (!options || options.length === 0) {
    return false;
  }
  return has(options[0], "options");
};

export const filterOptions = <T extends OptionOriginal>(
  options: SelectOptions<T> | undefined,
  searchTerm: string
): SelectOptions<T> => {
  const filterOptionsFnc = (flatOptions?: Option<T>[]) =>
    (flatOptions ?? []).filter(({ value }) =>
      (value ?? "").toLowerCase().includes((searchTerm ?? "").trim().toLowerCase())
    );

  if (areOptionsGrouped(options)) {
    return options
      .map((option) => ({ ...option, options: filterOptionsFnc(option.options) }))
      .filter(({ options }) => options.length > 0);
  } else {
    return filterOptionsFnc(options);
  }
};
